import {
    TableViewStore,
    BaseListViewStore
} from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import { observable, action } from 'mobx';

@applicationContext
class RoleViewStore extends BaseListViewStore {
    @observable accessor counter = 0;
    constructor(rootStore) {
        super(rootStore, {
            name: 'role',
            autoInit: true,
            authorization: {
                create: 'coreRoleSection.create',
                delete: 'coreRoleSection.delete',
            },
            routes: {
                create: () => this.rootStore.routerStore.goTo(
                    'master.app.main.role.create'
                ),
                edit: id => {
                    this.setChildNavigationTitle(i => i.id === id, r => r.name);
                    return this.rootStore.routerStore.goTo(
                        'master.app.main.role.edit',
                        { id: id }
                    )
                }
            },
            actions: () => {
                const service = rootStore.application.baasic.membershipModule.role;
                return {
                    find: async (params) => {
                        if(this.counter === 0)
						{
							params.orderBy = "name";
							params.orderDirection = "asc";
							this.counter++;
						}

                        const response = await service.find(params);
                        return response.data;
                    },
                    delete: async (item) => {
                        await service.remove(item);
                        // this.rootStore.notificationStore.success("Role successfully removed.");
                    }
                }
            }
        });

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: [
                {
                    key: 'name',
                    title: 'ROLE.LIST.COLUMNS.NAME',
                    onClick: item => this.routes.edit(item.id)
                },
                {
                    key: 'description',
                    title: 'ROLE.LIST.COLUMNS.DESCRIPTION',
                    onClick: item => this.routes.edit(item.id)
                }
            ],
            actions: {
                onEdit: async (item) => this.routes.edit(item.id),
                onDelete: (item) => this.deleteResource(item)
            }
        }));
    }

    @action.bound
    notifySuccessDelete() {
        this.rootStore.notificationStore.success('ROLE.DELETE.SUCCESS');
    }
}

export default RoleViewStore;
